import { useState } from "react";
import { Icon } from "../Icon.jsx";
import { XAI_SCHOOL_LINKS } from "../../data/consultantCourse.js";
import { BrandLockup } from "./BrandLockup.jsx";

const navigationItems = [
  ["Metodo", "#metodo"],
  ["Percorso", "#percorso"],
  ["Piani e prezzi", XAI_SCHOOL_LINKS.pricing],
  ["Per le organizzazioni", "#organizzazioni"],
];

export function LandingHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="landing-header">
      <BrandLockup
        nameHref="#inizio"
        onNavigate={closeMenu}
        schoolHref={XAI_SCHOOL_LINKS.home}
      />

      <nav aria-label="Navigazione principale" className="landing-header__nav">
        {navigationItems.map(([label, href]) => <a href={href} key={href}>{label}</a>)}
      </nav>

      <div className="landing-header__actions">
        <a className="landing-header__login" href={XAI_SCHOOL_LINKS.login}>Accedi</a>
        <a className="button button--coral landing-header__cta" href={XAI_SCHOOL_LINKS.assessment}>
          Fai il test <Icon name="arrow" size={17} />
        </a>
        <button
          aria-controls="landing-mobile-menu"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? "Chiudi il menu" : "Apri il menu"}
          className="landing-header__menu-button"
          onClick={() => setMenuOpen((current) => !current)}
          type="button"
        >
          <Icon name={menuOpen ? "close" : "menu"} size={22} />
        </button>
      </div>

      <nav
        aria-label="Navigazione mobile"
        className={menuOpen ? "landing-mobile-menu landing-mobile-menu--open" : "landing-mobile-menu"}
        id="landing-mobile-menu"
      >
        {navigationItems.map(([label, href]) => (
          <a href={href} key={href} onClick={closeMenu}>{label}<Icon name="arrow" size={17} /></a>
        ))}
        <a href={XAI_SCHOOL_LINKS.home} onClick={closeMenu} rel="noreferrer" target="_blank">
          Esplora gli altri corsi XAISchool <Icon name="arrow" size={17} />
        </a>
        <a href={XAI_SCHOOL_LINKS.login} onClick={closeMenu}>Accedi a XAISchool<Icon name="arrow" size={17} /></a>
        <a className="button button--coral" href={XAI_SCHOOL_LINKS.assessment} onClick={closeMenu}>
          Fai il test <Icon name="arrow" size={17} />
        </a>
      </nav>
    </header>
  );
}
